import { RouterProvider } from "react-router-dom";
import { ThemeProvider, ToastProvider } from "@/app/providers";
import { SessionProvider } from "@/auth/SessionProvider";
import { router } from "@/app/router";

export function App() {
  return (
    <ThemeProvider>
      <SessionProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </SessionProvider>
    </ThemeProvider>
  );
}
